const reg = {
  tel: /^[1][3,4,5,6,7,8][0-9]{9}$/, // 验证手机号
  switchText: /(\d{3})\d{4}(\d{4})/, // 转换为*
  userpwd: /^(?=.{8,})(((?=.*[A-Z])(?=.*[a-z0-9\W_]))|((?=.*[a-z])(?=.*[0-9\W_]))|((?=.*[0-9])(?=.*[\W_]))).*$/,
  mail: /[a-zA-Z0-9]{1,10}@[a-zA-Z0-9]{1,}\.[a-zA-Z0-9]{1,}/, // 判断是否为邮箱
  iccid: /^[a-zA-Z0-9]{20}$/, // iccid,联通sim
  ydSim: /^[0-9]{11}$/, // 移动sim
  barcode: /^(A027E00428)[a-zA-Z0-9]{20}/, // 终端条形码
  terminalcode: /^[1-9]\d{7}$/, // 终端编号
  vinno: /^[A-Za-z0-9]{17}$/, // vinno
  caralias: /^[A-Za-z0-9]{18}$/, // 整车物料
  newEnergyVehicle: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Za-z]{1}(([0-9]{5}[DdFf])|([DdFf][A-Ha-hJ-Nj-nP-Zp-z0-9][0-9]{4}))$/, // 新能源车
  fuelTruck: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Za-z]{1}[A-aH-hJ-jN-nP-pZ-z0-9]{4}[A-aH-hJ-jN-hP-pZ-z0-9挂学警港澳]{1})$/ // 燃油车
}
export default reg
